module.exports = __webpack_public_path__ + "static/media/user-add.99f489f5.svg";